export default "__VITE_ASSET__dFUjmAf___"